import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  MeetingsConductedChartOuter,
  CustomToolTipContent,
  CustomToolTipText,
  CustomToolTipBoldText,
} from "./styles";
import { format, startOfWeek, addDays } from "date-fns";

// const data = [
//   {
//     name: "Sun",
//     pv: 30,
//   },
//   {
//     name: "Mon",
//     pv: 52,
//   },
//   {
//     name: "Tue",
//     pv: 22,
//   },
//   {
//     name: "Wed",
//     pv: 38,
//   },
//   {
//     name: "Thu",
//     pv: 68,
//   },
//   {
//     name: "Fri",
//     pv: 18,
//   },
//   {
//     name: "Sat",
//     pv: 28,
//   },
// ];

// const getIntroOfPage = (label) => {
//   if (label === "Page A") {
//     return "Page A is about men's clothing";
//   }
//   if (label === "Page B") {
//     return "Page B is about women's dress";
//   }
//   if (label === "Page C") {
//     return "Page C is about women's bag";
//   }
//   if (label === "Page D") {
//     return "Page D is about household goods";
//   }
//   if (label === "Page E") {
//     return "Page E is about food";
//   }
//   if (label === "Page F") {
//     return "Page F is about baby food";
//   }
//   return "";
// };

const CustomTooltip = ({
  active,
  payload,
  label,
  monthName,
  currentMonthMeetingCounts,
  weekDays,
}) => {
  if (active && payload && payload.length) {
    const dayMap = {
      sun: "sunday",
      mon: "monday",
      tue: "tuesday",
      wed: "wednesday",
      thu: "thursday",
      fri: "friday",
      sat: "saturday",
    };

    const normalizedLabel = dayMap[label.toLowerCase()];
    let formattedWeekDay; 
    // Check if the normalized label exists in weekDays
    if (normalizedLabel && weekDays[normalizedLabel]) {
      const dateString = weekDays[normalizedLabel] + "T00:00:00";
      formattedWeekDay = format(new Date(dateString), "MMM d, yyyy");
    } else {
      console.warn(`Label "${label}" not found in weekDays or invalid`);
    }
    return (
      <CustomToolTipContent>
        <CustomToolTipText>{formattedWeekDay}</CustomToolTipText>
        <CustomToolTipText>
          {label}:{" "}
          <CustomToolTipBoldText>{payload[0].value}</CustomToolTipBoldText>
        </CustomToolTipText>
        <CustomToolTipText>
          {monthName}:{" "}
          <CustomToolTipBoldText>
            {currentMonthMeetingCounts}
          </CustomToolTipBoldText>
        </CustomToolTipText>
      </CustomToolTipContent>
    );
  }

  return null;
};

const MeetingsConductedChart = (props) => {
  const data = props?.data?.currentWeekMeetingCounts || [];
  const {
    monthName = "",
    currentMonthMeetingCounts = 0,
    weekDays = {},
  } = props?.data;
  return (
    <MeetingsConductedChartOuter>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{ top: 0, right: 0, left: -32, bottom: 0 }}
        >
          {/* {/ <CartesianGrid vertical={false} /> /} */}
          <XAxis
            dataKey="name"
            tick={{
              fontSize: 14,
              fill: "#302F2F",
              fontWeight: "400",
              fontStyle: "normal",
            }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 14,
              fill: "#302F2F",
              fontWeight: "400",
              fontStyle: "normal",
            }}
          />
          <Tooltip
          cursor={{ fill : "transparent"}}
            content={
              <CustomTooltip
                {...{ monthName, currentMonthMeetingCounts, weekDays }}
              />
            }
          />
          <Bar
            background={{ fill: "#eee" }}
            className="meetings-conducted-bar"
            dataKey="count"
            barSize={20}
            fill="#4D4D9F"
            radius={[5, 5, 5, 5]}
          />
        </BarChart>
      </ResponsiveContainer>
    </MeetingsConductedChartOuter>
  );
};

export default MeetingsConductedChart;
